const Chevron = require('components/Chevron/Chevron');
module.exports = Chevron;
